import { Box, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import './Milestones.css'


const Milestones = (props) => {
    const yearSelect= (year)=>{
    props.setYear(year);
    }
    
    return (
        <Box m={3}>
            <Link onClick={()=>yearSelect(props.item.year)} className='header'>
            <Typography variant='h5' className={props.year===props.item.year? 'selected':''}>{props.item.year}</Typography>
            </Link>
        </Box>
    )
}

export default Milestones